import _toConsumableArray from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import { createPopper } from "@popperjs/core";
import { getArrowStyles, toTransformOrigin } from "./popper.utils";
var isBrowser = typeof window !== "undefined";
var useSafeLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;
export function usePopper(props) {
  var _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? "bottom" : _props$placement,
      offsetProp = props.offset,
      _props$preventOverflo = props.preventOverflow,
      preventOverflow = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$forceUpdate = props.forceUpdate,
      forceUpdate = _props$forceUpdate === void 0 ? true : _props$forceUpdate,
      _props$flip = props.flip,
      flip = _props$flip === void 0 ? true : _props$flip,
      _props$arrowSize = props.arrowSize,
      arrowSize = _props$arrowSize === void 0 ? 10 : _props$arrowSize,
      arrowShadowColor = props.arrowShadowColor,
      _props$gutter = props.gutter,
      gutter = _props$gutter === void 0 ? arrowSize : _props$gutter,
      _props$eventsEnabled = props.eventsEnabled,
      eventsEnabled = _props$eventsEnabled === void 0 ? true : _props$eventsEnabled,
      modifiers = props.modifiers;
  var popper = React.useRef(null);
  var referenceRef = React.useRef(null);
  var popoverRef = React.useRef(null);
  var arrowRef = React.useRef(null);

  var _React$useState = React.useState(initialPlacement),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      originalPlacement = _React$useState2[0],
      place = _React$useState2[1];

  var _React$useState3 = React.useState(initialPlacement),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      placement = _React$useState4[0],
      setPlacement = _React$useState4[1];

  var _React$useState5 = React.useState(offsetProp || [0, gutter]),
      _React$useState6 = _slicedToArray(_React$useState5, 1),
      offset = _React$useState6[0];

  var _React$useState7 = React.useState({}),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      popoverStyles = _React$useState8[0],
      setPopoverStyles = _React$useState8[1];

  var _React$useState9 = React.useState({}),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      arrowStyles = _React$useState10[0],
      setArrowStyles = _React$useState10[1];

  var update = React.useCallback(function () {
    if (popper.current) {
      popper.current.forceUpdate();
      return true;
    }

    return false;
  }, []);
  var modifiersOverride = modifiers != null ? modifiers : [];
  useSafeLayoutEffect(function () {
    if (referenceRef.current && popoverRef.current) {
      popper.current = createPopper(referenceRef.current, popoverRef.current, {
        placement: originalPlacement,
        strategy: fixed ? "fixed" : "absolute",
        modifiers: [{
          name: "eventListeners",
          enabled: eventsEnabled
        }, {
          name: "applyStyles",
          enabled: false
        }, {
          name: "flip",
          enabled: flip,
          options: {
            padding: 8
          }
        }, {
          name: "computeStyles",
          options: {
            gpuAcceleration: false,
            adaptive: false
          }
        }, {
          name: "offset",
          options: {
            offset: offset
          }
        }, {
          name: "preventOverflow",
          enabled: preventOverflow,
          options: {
            tetherOffset: function tetherOffset() {
              var _arrowRef$current;

              return ((_arrowRef$current = arrowRef.current) == null ? void 0 : _arrowRef$current.clientWidth) || 0;
            }
          }
        }, {
          name: "arrow",
          enabled: Boolean(arrowRef.current),
          options: {
            element: arrowRef.current
          }
        }, {
          name: "updateState",
          phase: "write",
          enabled: true,
          fn: function fn(_ref) {
            var state = _ref.state;
            setPlacement(state.placement);
            setPopoverStyles(state.styles.popper);
            setArrowStyles(state.styles.arrow);
          }
        }].concat(_toConsumableArray(modifiersOverride))
      });
    }

    return function () {
      if (popper.current) {
        popper.current.destroy();
        popper.current = null;
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalPlacement, fixed, forceUpdate, flip, offset, preventOverflow, eventsEnabled]);
  useSafeLayoutEffect(function () {
    var id = requestAnimationFrame(function () {
      if (forceUpdate) {
        var _popper$current;

        (_popper$current = popper.current) == null ? void 0 : _popper$current.forceUpdate();
      }
    });
    return function () {
      cancelAnimationFrame(id);
    };
  }, [forceUpdate]);

  var computedArrowStyles = _extends({}, arrowStyles, getArrowStyles(placement, arrowSize, arrowShadowColor));

  return {
    popperInstance: popper.current,
    reference: {
      ref: referenceRef
    },
    popper: {
      ref: popoverRef,
      style: _extends({}, popoverStyles, {
        transformOrigin: toTransformOrigin(placement)
      })
    },
    arrow: {
      ref: arrowRef,
      style: computedArrowStyles
    },
    update: update,
    placement: placement,
    place: place
  };
}